import { render, staticRenderFns } from "./InterModal.vue?vue&type=template&id=648329ca"
import script from "./InterModal.vue?vue&type=script&lang=js"
export * from "./InterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports